export enum EPaymentMethod {
    EFT = 1,
    BPay = 2,
    CreditCard = 3,
    Cheque = 4
}
